import { render, staticRenderFns } from "./reviewCarousel.vue?vue&type=template&id=67135a5d&scoped=true"
import script from "./reviewCarousel.vue?vue&type=script&lang=js"
export * from "./reviewCarousel.vue?vue&type=script&lang=js"
import style0 from "./reviewCarousel.vue?vue&type=style&index=0&id=67135a5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67135a5d",
  null
  
)

export default component.exports